import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Grid, GridItem, Wrap, WrapItem } from '@chakra-ui/react';
import { Badge } from '@whitbread-eos/atoms';
import { BIGGER_ROOM_CODE, NEW_HOTEL_MESSAGING_FLAG_TEXT, NEW_ROOMS_MESSAGING_FLAG_TEXT, OPENING_SOON_MESSAGING_FLAG_TEXT, PREMIER_EXTRA_CODE, PREMIER_PLUS_FACILITY_CODE, MLOS } from '../../utils/constants';
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function HotelBadges(_ref) {
  var _premierPlusBadge$cod;
  var hasMlosRestriction = _ref.hasMlosRestriction,
    hotelOpeningDate = _ref.hotelOpeningDate,
    isHotelOpeningSoon = _ref.isHotelOpeningSoon,
    labels = _ref.labels,
    testId = _ref.testId,
    hotelFacilities = _ref.hotelFacilities,
    messagingFlag = _ref.messagingFlag,
    isColumnDisplay = _ref.isColumnDisplay,
    styles = _ref.styles;
  var badgeLegacyTypography = {
    fontSize: '13px'
  };
  var badgeSemanticTypography = {
    textStyle: 'label-s'
  };
  var premierPlusBadge = hotelFacilities === null || hotelFacilities === void 0 ? void 0 : hotelFacilities.find(facility => facility.code === PREMIER_PLUS_FACILITY_CODE);
  var hasBadges = hotelOpeningDate && isHotelOpeningSoon || premierPlusBadge || (messagingFlag === null || messagingFlag === void 0 ? void 0 : messagingFlag.text) && (messagingFlag === null || messagingFlag === void 0 ? void 0 : messagingFlag.text) !== 'hub' || hasMlosRestriction;
  var badges = _jsxs(_Fragment, {
    children: [hasMlosRestriction && renderHotelBadge({
      badgeColor: MLOS,
      badgeText: labels === null || labels === void 0 ? void 0 : labels.mlos,
      isColumnDisplay,
      variant: 'solid',
      badgeLegacyTypography,
      badgeSemanticTypography
    }), hotelOpeningDate && isHotelOpeningSoon && renderHotelBadge({
      badgeColor: OPENING_SOON_MESSAGING_FLAG_TEXT,
      badgeText: labels === null || labels === void 0 ? void 0 : labels.openingSoon,
      isColumnDisplay,
      badgeLegacyTypography,
      badgeSemanticTypography
    }), premierPlusBadge && renderHotelBadge({
      badgeColor: (_premierPlusBadge$cod = premierPlusBadge === null || premierPlusBadge === void 0 ? void 0 : premierPlusBadge.code) !== null && _premierPlusBadge$cod !== void 0 ? _premierPlusBadge$cod : '',
      badgeText: labels === null || labels === void 0 ? void 0 : labels.premierPlus,
      isColumnDisplay,
      badgeLegacyTypography,
      badgeSemanticTypography
    }), (messagingFlag === null || messagingFlag === void 0 ? void 0 : messagingFlag.text) && (messagingFlag === null || messagingFlag === void 0 ? void 0 : messagingFlag.text) !== 'hub' && renderHotelBadge({
      badgeColor: NEW_HOTEL_MESSAGING_FLAG_TEXT,
      badgeText: messagingFlag.text,
      isColumnDisplay,
      badgeLegacyTypography,
      badgeSemanticTypography
    })]
  });
  if (!hasBadges) {
    return null;
  }
  return isColumnDisplay ? _jsx(Grid, _objectSpread(_objectSpread({}, styles), {}, {
    "data-testid": testId,
    templateColumns: "repeat(2, 1fr)",
    justifyItems: "flex-start",
    gridGap: "sm",
    width: "fit-content",
    children: badges
  })) : _jsx(Wrap, _objectSpread(_objectSpread({}, styles), {}, {
    "data-testid": testId,
    children: badges
  }));
}
function renderHotelBadge(_ref2) {
  var badgeColor = _ref2.badgeColor,
    badgeText = _ref2.badgeText,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'secondary' : _ref2$variant,
    isColumnDisplay = _ref2.isColumnDisplay,
    badgeLegacyTypography = _ref2.badgeLegacyTypography,
    badgeSemanticTypography = _ref2.badgeSemanticTypography;
  if (!badgeText) {
    return null;
  }
  var badge = _jsx(Badge, {
    badgecolor: getColor(badgeColor),
    color: variant === 'secondary' ? getColor(badgeColor) : 'baseWhite',
    variant: variant,
    badgeLegacyTypography: badgeLegacyTypography,
    badgeSemanticTypography: badgeSemanticTypography,
    width: "100%",
    textAlign: "center",
    cursor: "pointer",
    children: badgeText
  });
  return isColumnDisplay ? _jsx(GridItem, {
    width: "100%",
    children: badge
  }) : _jsx(WrapItem, {
    children: badge
  });
}
export function getColor(label) {
  switch (label) {
    case BIGGER_ROOM_CODE:
      return 'lightPurple';
    case PREMIER_PLUS_FACILITY_CODE:
      return 'primary';
    case NEW_HOTEL_MESSAGING_FLAG_TEXT:
    case NEW_ROOMS_MESSAGING_FLAG_TEXT:
    case OPENING_SOON_MESSAGING_FLAG_TEXT:
      return 'maroon';
    case PREMIER_EXTRA_CODE:
      return 'blue';
    case MLOS:
      return 'green';
    default:
      return 'darkPink';
  }
}